// @ts-nocheck
import _ from 'lodash';

const randint = _.random;

const stringHash = str => {
  let hash = 0,
    i = 0;
  const len = str.length;
  while (i < len) {
    hash = ((hash << 5) - hash + str.charCodeAt(i++)) << 0;
  }
  return hash;
};

const randintWithSeed = seed => (lower, upper) => {
  // TODO: not a great rng
  let x = Math.sin(seed++) * 10000;
  x = x - Math.floor(x);

  return lower + Math.floor(x * (upper - lower + 1));
};

const choice = (iterable, _randint: (lower: number, upper: number) => number = randint) => {
  const index = _randint(0, iterable.length - 1);
  return iterable[index];
};

const sample = (iterable, size, _randint = randint) => {
  const shuffled = shuffle(iterable, size, _randint);
  return shuffled.slice(0, size);
};

const shuffle = (iterable, upto = null, _randint = randint) => {
  const newIterable = iterable.slice();
  const maxItem = upto === null ? newIterable.length - 1 : upto;
  for (const idx of _.range(0, maxItem)) {
    const swapIdx = _randint(idx, newIterable.length - 1);
    const swap = newIterable[swapIdx];
    newIterable[swapIdx] = newIterable[idx];
    newIterable[idx] = swap;
  }
  return newIterable;
};

export default {
  stringHash,
  randint,
  randintWithSeed,
  choice,
  sample,
  shuffle,
};
